import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TableColumn } from '../../table.model';
import { CellRenderer } from '../cell-renderer';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'cbre-statistical-cell-renderer, [cbreStatisticalCellRenderer]',
  imports: [CommonModule, MatIconModule, MatTooltipModule],
  template: `
    <div class="fx--h fx--juc-start fx--ali-center chip">
      <!-- principal column -->
      <ng-container *ngIf="is_statistical">
        <!-- unit -->
        <span [matTooltip]="tooltip" matTooltipPosition="above" matTooltipClass="tooltip-action-icon">
          <mat-icon svgIcon="statistical"></mat-icon>
        </span>
        &nbsp;
      </ng-container>
    </div>
  `,
})
export class StatisticalCellRendererComponent implements CellRenderer<TableColumn> {
  @Input() set data(value: Record<string, any>) {
    this.is_statistical = value?.usages?.[0]?.statistical_f ?? false;
  }

  @Input() set config(config: TableColumn) {
    this.tooltip = config?.tooltip ?? '';
  }

  is_statistical = false;
  tooltip = '';

  render(): void {
    // required by CellRenderer
  }
}
